"use strict";

define('components/lead_capture_form',['components/dom_setup', 'components/ajax', 'components/form'], function(domSetup, ajax, formCmp) {

    var leadCaptureForm = {
        init: function() {

            var leadCaptureFormContainer = $('#lead-capture-form-container');
            leadCaptureFormContainer.append(
                '<div class="module-overlay hidden"><img src="/static/spinner_sm.gif" width="16" height="16"></div>');

            var formNode = $('#lead_capture_form');

            $('#lead-capture-form-btn-submit').click(function(e) {
                e.preventDefault();
                e.stopPropagation();
                var formData = formCmp.serialize(formNode);

                // Don't POST when the user hasn't completed the reCAPTCHA challenge.
                var gRecaptchaResponseElement = $("textarea[name='g-recaptcha-response']");
                if (gRecaptchaResponseElement.length && gRecaptchaResponseElement.val()) {

                    // Show the overlay while waiting for the ajax request to complete
                    leadCaptureFormContainer.find('.module-overlay').removeClass('hidden');

                    ajax($(location).attr('href'), {  // POST to the same URL
                        formData: formData,
                        onFailure: function(result) {
                            $('#lead-capture-form-wrapper').replaceWith(result.body);
                            require(['components/dom_setup'], function(domSetup) {
                                domSetup.init($('#lead-capture-form-wrapper'));
                            });
                            return true;
                        }
                    });
                }
            });
        }
    };

    return leadCaptureForm;
});

